import { createFileRoute } from "@tanstack/react-router";
import { NotesGrid } from "../components/NotesGrid";

export const Route = createFileRoute("/archive")({
  component: () => <NotesGrid title="Archive" filter={{ archived: true, trashed: false }} />,
});
